import { whatChanged } from './whatChanged';
import { price } from './price';
import { ruleFired } from './ruleFired';
import { arithmetic } from './arithmetic';
export { whatChanged } from './whatChanged';
export { price } from './price';
export { ruleFired } from './ruleFired';
export { arithmetic } from './arithmetic';
export { debrief, debriefHand } from './debrief';
/**
 * The full in-hand factual line set for one decision point, in reading order: what changed since the
 * last street, the price/SPR/equity math, the recommendation + fired-rule principles, and (once hero
 * has acted) the bet-math feedback. This is the deterministic $0 coaching surface AND the mandatory
 * fallback when the LLM narrator is unavailable (ENGINE_DESIGN.md §8.2).
 */
export function renderAllTemplates(facts) {
    return [...whatChanged(facts), ...price(facts), ...ruleFired(facts), ...arithmetic(facts)];
}
//# sourceMappingURL=index.js.map